module.exports = __webpack_public_path__ + "img/bank-line.a0fd3698.svg";